import { State } from "@store/types";
import { FilterParameter } from "@src/utils/networks";
import { Optional } from "hyphen-lib/dist/lang/Optionals";

export function getFilter(state: State): Optional<FilterParameter> {
  return state.insights_actionList_filter.filter;
}
